<div class="alert" [ngClass]="color">
  <div class="alert--icon">
    <mat-icon>{{ setIcon(color) }}</mat-icon>
  </div>
  <div tabindex="0" [ngClass]="display">
    <div class="alert--header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="alert--content">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
  <div tabindex="0" *ngIf="close" class="alert--close" (keydown)="keyboardClose($event)">
    <a
      role="button"
      class="seds-link seds-flex seds-items-center"
      aria-label="Fechar mensagem"
      (click)="hasClosed.emit()">
      <mat-icon>close</mat-icon>
    </a>
  </div>
</div>
